/**
 * 탭 챕터 잠금 — Phaser 의존 0의 순수 판정 모듈 (단위 테스트 대상).
 *
 * systemUnlocks.tsv의 tab 행과 현재 최고 도달 챕터(bestChapter)만으로 잠금 여부를 결정한다.
 * 배지 렌더(SegmentedTabBar)·클릭 거부(TabRouter)·잠금 갱신(GameScene)은 이 순수 판정을 소비만 한다.
 *
 * 잠금 기준 = bestChapter(환생해도 유지되는 최고 도달치) → 한 번 해제한 챕터는 환생 후에도 잠기지 않는다.
 */
import { tabRequiredBestChapter } from "../data/systemUnlockData.js";
import { TAB_ORDER, type TabId } from "./tabCatalog.js";

/** 탭이 해제되는 최소 챕터. unlockChapter 미지정 탭은 1(상시 해제). */
export function tabUnlockChapter(id: TabId): number {
  return tabRequiredBestChapter(id);
}

/**
 * 모든 탭을 해제하는 데 필요한 최소 bestChapter — 카탈로그 전 탭 unlockChapter의 최댓값.
 * "모든 탭 잠금 해제" 치트가 bestChapter를 올릴 목표값(데이터 파생 — 향후 탭 추가 시 자동 반영).
 */
export function maxTabUnlockChapter(): number {
  let max = 1;
  for (const id of TAB_ORDER) {
    const c = tabUnlockChapter(id);
    if (c > max) max = c;
  }
  return max;
}

/** 탭 잠금 여부 — bestChapter가 해제 챕터 미만이면 잠김. */
export function isTabLocked(id: TabId, bestChapter: number): boolean {
  return bestChapter < tabUnlockChapter(id);
}
